// removed by extract-text-webpack-plugin
module.exports = {"container":"oVbceCHDsOJpM-rhZcdb6","link":"_3BptJo2G6u4-gQRS8BmfVw"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/styles.css
// module id = 1433
// module chunks = 0